import { useIsFbBrowser, useIsIos } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import EmailAuthButton from 'containers/EmailAuthButton'
import FacebookButton from 'containers/FacebookButton'
import GoogleAuthButton from 'containers/GoogleAuthButton'
import useReferredBySessionStorage from 'hooks/useReferredBySessionStorage'
import content from 'prismic-translates/auth-pages.json'

const t = getTranslationFromJson([content])

// import AppleAuthButton from '../AppleAuthButton'

function RegisterButtons({ isFBAudience }: { isFBAudience: boolean }) {
  const fbBrowser = useIsFbBrowser()
  const isIos = useIsIos()
  // const hideAppleButton = !fbBrowser && IS_BRAND_PULSZ
  useReferredBySessionStorage()

  return (
    <>
      {!isFBAudience && <FacebookButton authType='REGISTRATION' text={t('sign_up_with_facebook')} />}

      <EmailAuthButton authType='REGISTRATION' title={t('sign_up_with_email')} />

      {/*
          google auth button
          hidden on fb browser on ios only
          hidden on react native android app
        */}
      {(() => {
        if (fbBrowser && isIos) {
          return null
        }

        return <GoogleAuthButton authType='REGISTRATION' title={t('sign_up_with_google')} />
      })()}
      {/* @TODO - need add check on serviceAppleId when will get it with backend  */}
      {/* {hideAppleButton && <AppleAuthButton title={t('Sign up with Apple')} authType={'REGISTRATION'} />} */}
    </>
  )
}

export default RegisterButtons
